import React from 'react';
import GoogleLogin from 'react-google-login';
import { useDispatch } from 'react-redux';
import { useHistory } from 'react-router'
import { toast } from 'react-toastify';
import googlePng from '../../assets/images/google.svg';
import { Put} from '../../Api/ApiMethods.js';
import { 
  googleLoginUrl
 } from '../../Routes/ApiRoutes';
 import FacebookLogin from 'react-facebook-login';


export default function FbLogin(props) {
    const history = useHistory()
	const dispatch = useDispatch();

    const onSuccess=(re) => {
        if(props.termCondition)
        {
          try {
            Put(googleLoginUrl, {'access_token':re.accessToken})
            .then(response => {
              toast.success("Logged in sucessfully.")
              dispatch({
                type: 'SIGN_IN',
                payload: response.data.token,
              });
              dispatch({
                type: 'ADMIN_DATA',
                payload: response.data.user,
              });
              setTimeout(()=>history.push('/home'),2100)
              })
            .catch(error => {
              console.log(error)
            })
          }catch (error) {
            console.log(error);
          }
        }
        else{
          toast.error("Please accept terms and condition to continue.")
        }
    }
    const onFailure=(res) => {
        console.log(res)
    }
    return (
        <>
        {/* <GoogleLogin
          render={renderProps => (
            <img className='link' onClick={renderProps.onClick} disabled={renderProps.disabled} src={googlePng} />
          )}
          clientId={process.env.React_App_Google_Login_Client_Id}
          onSuccess={(re)=>onSuccess(re)}
          onFailure={(res)=>onFailure(res)}
          cookiePolicy={'single_host_origin'}
          isSignedIn={false}
      /> */}
        <FacebookLogin
         render={renderProps => (
            <img className='link' onClick={renderProps.onClick} disabled={renderProps.disabled} src={googlePng} />
          )}
        appId="1088597931155576"
        autoLoad={true}
        fields="name,email,picture"
        // onClick={componentClicked}
        // callback={responseFacebook} 
        />
      </>
    )
}